import React from 'react';
import { useSelector } from 'react-redux';
import { DocumentId } from 'services/documents/types';
import { AppState } from 'services/types';
import { selectDocumentCreatedBy } from './selectors';

interface Props {
    documentId: DocumentId;
}

function DocumentCreatedBy({ documentId }: Props): React.ReactElement {
    const documentCreatedBy = useSelector((state: AppState) =>
        selectDocumentCreatedBy(state, { documentId })
    );

    return <span>{documentCreatedBy}</span>;
}

export default DocumentCreatedBy;
